var _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_24",
    "data-name": "Component 4 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22.001,
    viewBox: "0 0 22.001 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M11,311.4a11,11,0,1,0,0,22,10.9,10.9,0,0,0,4.261-.864l3.707.848a.635.635,0,0,0,.141.016.628.628,0,0,0,.624-.7l-.372-3.167A10.987,10.987,0,0,0,11,311.4m7.236,17.508a.629.629,0,0,0-.157.494l.3,2.559-3.039-.695a.634.634,0,0,0-.4.038,9.788,9.788,0,1,1,3.291-2.4",
    transform: "translate(0 -311.402)",
    fill: "#4e428d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(10.887 13.835)",
    fill: "#4e428d",
    fontSize: 14,
    fontFamily: "LiGothicMed, Apple LiGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.428,
    y: 0
  }, "i"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon8);
export default __webpack_public_path__ + "static/media/evolbs_icon8.5d3d44d3.svg";
export { ForwardRef as ReactComponent };